import {
    commonEn,
    enumEn,
    errorEn,
    manageMeetingEn,
    manageRoleEn,
    managePositionEn,
    manageUnitEn,
    monitorEn,
    packageManagementEn,
    pgAccessEn,
    pgMeetingEn,
    pgProfileEn,
    pgRecordingsEn,
    pgRoleEn,
    pgStorageEn,
    pgUserEn,
    pgWhiteboardsEn,
    translationEn,
    manageUserEn
} from './locales/en';
import {
    commonVi,
    enumVi,
    errorVi,
    manageMeetingVi,
    manageRoleVi,
    managePositionVi,
    manageUnitVi,
    monitorVi,
    packageManagementVi,
    pgAccessVi,
    pgMeetingVi,
    pgProfileVi,
    pgRecordingsVi,
    pgRoleVi,
    pgStorageVi,
    pgUserVi,
    pgWhiteboardsVi,
    translationVi,
    manageUserVi
} from './locales/vi';

export const i18nConfig = {
    en: {
        translation: translationEn,
        common: commonEn,
        enum: enumEn,
        error: errorEn,
        pgRecordings: pgRecordingsEn,
        pgWhiteboards: pgWhiteboardsEn,
        pgAccess: pgAccessEn,
        pgUser: pgUserEn,
        pgMeeting: pgMeetingEn,
        pgProfile: pgProfileEn,
        pgRole: pgRoleEn,
        packageManagement: packageManagementEn,
        pgStorage: pgStorageEn,
        manageRole: manageRoleEn,
        manageMeeting: manageMeetingEn,
        managePosition: managePositionEn,
        manageUnit: manageUnitEn,
        manageUser: manageUserEn,
        monitor: monitorEn,
    },
    vi: {
        translation: translationVi,
        common: commonVi,
        enum: enumVi,
        error: errorVi,
        pgRecordings: pgRecordingsVi,
        pgWhiteboards: pgWhiteboardsVi,
        pgAccess: pgAccessVi,
        pgUser: pgUserVi,
        pgMeeting: pgMeetingVi,
        pgProfile: pgProfileVi,
        pgRole: pgRoleVi,
        packageManagement: packageManagementVi,
        pgStorage: pgStorageVi,
        manageRole: manageRoleVi,
        manageMeeting: manageMeetingVi,
        managePosition: managePositionVi,
        manageUnit: manageUnitVi,
        manageUser: manageUserVi,
        monitor: monitorVi
    }
}
